import React from 'react';
import {
  Box, Typography,
} from 'vindi-ds-components';

function ProductDescription({ description }) {
  return (
    <Box>
      <Typography variant='body2' component='p'>
        Observação
      </Typography>
      <Typography variant='body1' component='p'>
        {description}
      </Typography>
    </Box>
  );
}

export default ProductDescription;
